import { FieldErrorCodes } from 'consts/enums';
import React, { isValidElement } from 'react';
import { string, object } from 'prop-types';

const defaultErrorFieldTemplate = {
  fieldName: 'Value',
};

const ErrorMessage = ({
  rawMessage,
  errorFieldTemplate = defaultErrorFieldTemplate,
}) => {
  let formatErrorMessageWithFieldName = rawMessage;

  Object.keys(errorFieldTemplate).forEach((key) => {
    formatErrorMessageWithFieldName = formatErrorMessageWithFieldName.replace(
      new RegExp(`{${key}}`, 'g'),
      errorFieldTemplate[key]
    );
  });

  return <>{formatErrorMessageWithFieldName}</>;
};

ErrorMessage.propTypes = {
  rawMessage: string,
  errorFieldTemplate: object,
};

export const createErrorMessage = (data) => {
  let errorMessage;

  // Using switch to achieve more flexible data handling
  // Each case can have its own logic
  switch (data.fieldErrorCode) {
    case FieldErrorCodes.FieldRequired: {
      errorMessage = `This field is a mandatory field`;
      break;
    }
    case FieldErrorCodes.InvalidType: {
      errorMessage = 'Invalid value';
      break;
    }
    case FieldErrorCodes.MinLength: {
      errorMessage = `This is too short, please provide at least ${data.extraData.validateValue} characters`;
      break;
    }
    case FieldErrorCodes.MaxLength: {
      errorMessage = `This is too long, please provide ${data.extraData.validateValue} or less characters`;
      break;
    }
    case FieldErrorCodes.MinItems: {
      errorMessage = `Please select at least ${
        data.extraData.validateValue
      } item${data.extraData.validateValue === 1 ? '' : 's'}`;
      break;
    }
    case FieldErrorCodes.MaxItems: {
      errorMessage = `Please select at most ${data.extraData.validateValue} items`;
      break;
    }
    case FieldErrorCodes.InvalidPattern: {
      errorMessage = 'Invalid {fieldName} format';
      break;
    }
    // Specific messages
    case FieldErrorCodes.CompanyNameAlreadyExists: {
      errorMessage = 'Company name already exists';
      break;
    }
    case FieldErrorCodes.ImageIsTooBig: {
      errorMessage = 'Image is too big';
      break;
    }
    case FieldErrorCodes.HqLocationIsNotInCompanyLocations: {
      errorMessage = 'Headquarter location is not in company locations';
      break;
    }
    case FieldErrorCodes.InvalidEmail: {
      errorMessage = 'Invalid email';
      break;
    }
    case FieldErrorCodes.NameAlreadyExists: {
      errorMessage = 'Name already exists';
      break;
    }
    case FieldErrorCodes.EditingPublishedArticle: {
      errorMessage = 'Article is published. Unpublish to change this field';
      break;
    }
    default:
      throw new Error(
        `createErrorMessage: unknown fieldErrorCode '${data.fieldErrorCode}'`
      );
  }

  return <ErrorMessage rawMessage={errorMessage} />;
};

export const formatErrorMessage = (
  renderedErrorMessage,
  errorFieldTemplate
) => {
  if (!renderedErrorMessage) {
    return null;
  }

  if (
    isValidElement(renderedErrorMessage) &&
    renderedErrorMessage.type === ErrorMessage
  ) {
    const { rawMessage } = renderedErrorMessage.props;

    return (
      <ErrorMessage
        rawMessage={rawMessage}
        errorFieldTemplate={errorFieldTemplate}
      />
    );
  }

  return renderedErrorMessage;
};
